class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.acompanhaTeclado();
  }

  /* TECLADO DO IOS x RODAPE DA GAVETA.

     No iOS o teclado não encolhe o layout viewport: a gaveta continua com a
     altura da tela inteira, o Safari rola a página atrás do campo em foco e o
     rodapé (cupom, desconto, total e o botão de finalizar) some atrás do
     teclado — justamente na hora de fechar a compra. Só o viewport VISUAL
     encolhe, então é ele que a gaveta passa a medir enquanto há campo em foco. */
  acompanhaTeclado() {
    const vv = window.visualViewport;
    if (!vv) return;

    const ajustar = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      this.style.setProperty('--cdv2-teclado-h', `${vv.height}px`);
      this.style.top = `${vv.offsetTop}px`;
      this.style.height = `${vv.height}px`;
      // A classe desliga a regra de tela curta do Dawn. Ver o comentário dela
      // em component-cart-drawer.css.
      this.classList.add('cdv2-teclado');
    };

    const soltar = () => {
      this.style.removeProperty('--cdv2-teclado-h');
      this.style.top = '';
      this.style.height = '';
      this.classList.remove('cdv2-teclado');
    };

    this.addEventListener('focusin', (evt) => {
      if (!evt.target.matches('input, textarea, select')) return;
      this.campoEmFoco = true;
      ajustar();
      // O teclado sobe DEPOIS do foco: o resize do viewport visual é o sinal real.
      vv.addEventListener('resize', ajustar);
      vv.addEventListener('scroll', ajustar);
    });

    this.addEventListener('focusout', () => {
      this.campoEmFoco = false;
      // Pular de um campo para o outro dispara focusout antes do focusin
      // seguinte; sem a folga a gaveta piscaria de volta para a tela inteira.
      setTimeout(() => {
        if (this.campoEmFoco) return;
        vv.removeEventListener('resize', ajustar);
        vv.removeEventListener('scroll', ajustar);
        soltar();
      }, 120);
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
